import React, { Component } from 'react';
import { Tabs, Divider } from 'antd';

import MachineLogListContainer from '../containers/MachineLogListContainer';
import MachineLogAddContainer from '../containers/MachineLogAddContainer';
import MachineRepairsAddContainer from '../containers/MachineRepairsAddContainer';
import MachineRepairsListContainer from '../containers/MachineRepairsListContainers';
import MachineQuotationsAddContainer from '../containers/MachineQuotationsAddContainer';
import MachineQuotationListContainer from '../containers/MachineQuotationListContainer';
import MachineDiagramsAddContainer from '../containers/MachineDiagramsAddContainer';
import MachineDiagramListContainer from '../containers/MachineDiagramListContainer';
import MachineManagersContainer from '../containers/MachineManagersContainer';
import MachineContactsAddContainer from '../containers/MachineContactsAddContainer';
import MachineTimersListContainer from '../containers/MachineTimersListContainer';
import MachineTimersAddContainer from '../containers/MachineTimersAddContainer';

import './MachineDetailsView.css';
import MachineDetailsHeaderContainer from '../containers/MachineDetailsHeaderContainer';


class MachineDetails extends Component {
    render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <MachineDetailsHeaderContainer
                    machineId={this.props.machineId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                />

                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="Bitacora" key="1">
                        <MachineLogListContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                        <Divider />
                        <MachineLogAddContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Tickets" key="2">
                        <MachineRepairsListContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                        <Divider />
                        <MachineRepairsAddContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Cotizaciones" key="3">
                        <MachineQuotationListContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                        <Divider />
                        <MachineQuotationsAddContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Diagramas" key="4">
                        <MachineDiagramListContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                        <Divider />
                        <MachineDiagramsAddContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Timers" key="5">
                        <MachineTimersListContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                        <Divider />
                        <MachineTimersAddContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Contactos" key="6">
                        <MachineManagersContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                        <Divider />
                        <MachineContactsAddContainer
                            machineId={this.props.machineId}
                            user={this.props.user}
                            extraUser={this.props.extraUser}
                        />
                    </Tabs.TabPane>
                </Tabs>
            </div>
        );
    }
}
export default MachineDetails;



// WEBPACK FOOTER //
// ./src/components/views/MachineDetailsView.js